goog.module('yext.subscriptions.routes');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');

/**
 * Helper method for routes, copied from js/yext/storm/router.js and modified for subscriptions usage.
 *
 * @param {string} path within storm with placeholders
 * @return {function(object): string} to be called with key/values
*/
function _route(path) {
  return function(obj) {
    var pattern = '/subscriptions/' + path;
    obj = obj || {};
    var queryParams = [];
    for (var key in obj) {
      var vals = obj[key];
      if (!Array.isArray(obj[key])) {
        vals = [obj[key]];
      }
      for (var i = 0; i < vals.length; i++) {
        var val = encodeURIComponent(vals[i]);
        var pattern2 = pattern.replace(':'+key, val);
        if (pattern == pattern2) {
          queryParams.push(key + '=' + val);
        }
        pattern = pattern2;
      }
    }
    if (queryParams.length > 0) {
      pattern += '?' + queryParams.join('&');
    }
    return pattern;
  };
}

const Apps = {
  appFeaturesTable: _route('apps/:appId/appFeaturesTable'),
};

const LockedPastedDueAccount = {
  renderDialog: _route('renderLockedAccountDialog'),
  renderEditCardDialog: _route('renderEditCreditCardInfo'),
  renderNewCreditCardAddress: _route('renderNewCreditCardAddress'),
  chargePaymentMethod: _route('chargePaymentMethod'),
};

exports = {
  Apps,
  LockedPastedDueAccount,
};
